const form = {
  formId: "custom-link-form",
  formField: {
    title: {
      name: "title",
      label: "Title showed",
      placeholder: "Enter the title to show in the menu",
      type: "text",
    },
    url: {
      name: "url",
      label: "URL link",
      placeholder: "Enter the URL for the link",
      type: "text",
    },
  },
};

export default form;
